export default __webpack_public_path__ + "70553d75b1b402fc6a40a5c59915135b.png";